
import { MapTo } from '@adobe/aem-react-editable-components';
import HeroBenefitsCta, { HeroBenefitsCtaEditConfig } from './HeroBenefitsCta';

export default MapTo('cob-corp-acquisition/components/creditonebank/hero-benefits-cta')(HeroBenefitsCta, HeroBenefitsCtaEditConfig);
        